
import effectsConfig from "./effectsConfig"; // Steuerung
import Snowfall from "./Snowfall";
import LightningEffect from "./LightningEffect";
import FireballEffect from "./FireballEffect";

const EffectsController = () => {
  return (
    <>
      {effectsConfig.snowfall && <Snowfall />}
      {effectsConfig.lightning && <LightningEffect />}
      {effectsConfig.fireball && <FireballEffect />}
    </>
  );
};

export default EffectsController;
